import { upperFirst } from 'lodash';
export const toUpperFirstWithSpace = (text: string) => {
  const formatted = text.replace(/_|-/g, ' ');
  return upperFirst(formatted);
};
